import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import StatCard from '../components/dashboard/StatCard';
import RecentMatches from '../components/dashboard/RecentMatches';
import { handleAuthError } from '../utils/auth';

const DashboardPage = () => {
  const location = useLocation(); // Get location object from react-router-dom
  const navigate = useNavigate(); // Get navigate function
  const [stats, setStats] = useState({
    totalMatches: 0,
    winRate: '0%',
    currentStreak: '0 wins',
    thisMonth: 0,
  });
  const [recentMatches, setRecentMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem('token'); // Retrieve JWT token
        if (!token) {
          handleAuthError(navigate); // Redirect to landing page if no token
          return;
        }

        const response = await fetch('https://best3intennis.com/best3intennis-api/api/dashboard.php', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}` // Send JWT token in Authorization header
          },
          // credentials: 'include', // Not needed for JWT
        });

        if (!response.ok) {
          const data = await response.json().catch(() => null); // Try to parse error response
          if (data && (data.message?.includes('token') || data.error?.includes('token'))) {
            handleAuthError(navigate);
            return;
          }
          throw new Error('Failed to fetch dashboard data.');
        }

        const data = await response.json();
        // This check might be redundant if the !response.ok block handles it, but good for safety
        if (data.message?.includes('token') || data.error?.includes('token')) {
          handleAuthError(navigate);
          return;
        }
        setStats(data.stats);
        setRecentMatches(data.recentMatches);
      } catch (err) {
        if (err.message.includes('401')) {
          handleAuthError(navigate);
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [localStorage.getItem('token'), location.state]); // Re-fetch if token changes or match completed state is passed

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    // Instead of displaying the error, you could redirect or show a generic message
    // For now, we'll keep it simple. In a real app, you might want to navigate away.
    return <div>Error: {error}</div>;
  }

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard 
          title="Total Matches" 
          value={stats.totalMatches} 
          icon="🏆"
          onClick={() => navigate('/history')}
        />
        <StatCard title="Win Rate" value={stats.winRate} icon="🎯" />
        <StatCard title="Current Streak" value={stats.currentStreak} icon="📈" />
        <StatCard title="This Month" value={stats.thisMonth} icon="📅" />
      </div>

      <RecentMatches matches={recentMatches} />
    </div>
  );
};

export default DashboardPage;


